
import logo from './safo1.png';

export default logo;